import * as React from 'react';

import { getTermsValue, NonEmptyArray } from '../../../../../JsonQuery';
import { EGarageType } from '../../../../../api-models/common/json_query';
import { GarageType } from '../../../components/advancedFilters/GarageType';
import { useFiltersContext } from '../../../utils/useFiltersContext';

export const GarageTypeContainer: React.FC = () => {
  const { jsonQuery, onChange } = useFiltersContext();
  const garageTypes = getTermsValue('garage_type')(jsonQuery);

  const handleChange = React.useCallback(
    (garageTypes: NonEmptyArray<EGarageType> | null) => {
      onChange({ action: 'setGarageTypes', arguments: [garageTypes] });
    },
    [onChange],
  );

  return <GarageType value={garageTypes as NonEmptyArray<EGarageType> | null} onChange={handleChange} />;
};
